var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrees2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 253,
    viewBox: "0 0 124 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees-2",
    transform: "translate(-580 -4234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2995",
    "data-name": "Rectangle 2995",
    width: 124,
    height: 124,
    rx: 62,
    transform: "translate(580 4234)",
    fill: "#546c5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 15,
    height: 194,
    rx: 7.5,
    transform: "translate(635 4293)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M3,34.717a2,2,0,0,1,3.993,0l2.882,50.1a2,2,0,0,1-2,2.115H2.118a2,2,0,0,1-2-2.115Z",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 674.672, 4279.833)",
    fill: "#2f2f2e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees2);
export default __webpack_public_path__ + "static/media/trees-2.d1cb521eda290f4ccbbddfd3611e163d.svg";
export { ForwardRef as ReactComponent };